<template>
  <section id="maps">
    <mdb-row>
      <mdb-col md="12">
        <mdb-card cascade narrow class="mt-5">
          <mdb-view class="gradient-card-header elegant-color-dark">
            <h4 class="h4-responsive text-white">
              Map
            </h4>
          </mdb-view>
          <mdb-card-body class="text-center">
            <GmapMap
              :center="location"
              :zoom="zoomLevel"
              map-type-id="satellite"
              style="width: 100%; height: 800px"
            />
          </mdb-card-body>
        </mdb-card>
      </mdb-col>
    </mdb-row>
  </section>
</template>

<script>
import {
  mdbRow,
  mdbCol,
  mdbCard,
  mdbView,
  mdbCardBody,
} from "mdbvue";
import { mapService } from "@/services/map.service";

export default {
  name: "Map",
  components: {
    mdbRow,
    mdbCol,
    mdbCard,
    mdbView,
    mdbCardBody,
  },
  props: {
    address: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      location: { lng: 10, lat: 10 },
      zoomLevel: 16
    };
  },
  watch: {
    address(value) {
      this.address = value;
      this.getLocation();
    }
  },
  methods: {
    getLocation() {
      if (this.address.length > 4) {
        mapService.getLongLat(this.address).then(resp => {
          const data = resp.geometry && resp.geometry.location;
          this.location = { lng: data.lng, lat: data.lat };
        });
      }
    }
  }
};
</script>

